import { Fetch } from 'lib';
import type { DiscountCode } from 'types';

type RequestResponses = DiscountCode;

type RequestParameters = {};

type RequestBody = Prettify<
  StrictOmit<DiscountCode, 'id' | 'products' | 'brands' | 'categories'> &
    Partial<Record<'productsIds' | 'brandsIds' | 'categoriesIds', string[]>>
>;

const createDiscountCode = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminDiscountCode/createDiscountCode',
    method: 'POST',
    body,
  });

export { createDiscountCode };
